import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous.gallery_areas",
    activeSearch: false,
    target: "configuration",
    domain: [],
    fields: {
      title: { type: "char" },
      image: { type: "char" },
      video: { type: "char" },
      desc: { type: "text" },
    },
    list: [{ name: "title" }, { name: "desc" }],
    form: [
      { name: "title" },
      { name: "desc" },
      { name: "image" },
      { name: "video" },
    ],
  });
}

export default { ctxView: getView };
